import logo from '@/assets/icons/logo.png';

export const BG_COVER = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/BG_COVER.jpg?updatedAt=1728368093926`;
export const BG_WELCOMING_SECTION = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/BG_WELCOMING_SECTION.jpg?updatedAt=1728368094242`;
export const BG_COUNTING = `https://user-images.githubusercontent.com/10141928/146292235-21d28e45-72b7-41e1-90ac-26a3605529e2.jpg`;
export const BG_IG_FILTER = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/Cover.jpg?updatedAt=1728369574841`;
export const BG_DESKTOP_VIEW = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/BG_DESKTOP_VIEW.jpg?updatedAt=1728368092368`;

export const IMG_AYAT = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_AYAT.jpg?updatedAt=1728368093747`;
export const IMG_LOGO = logo;

export const IMG_MAN = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_MAN.jpg?updatedAt=1728368094292`;
export const IMG_GIRL = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_GIRL.jpg?updatedAt=1728368094288`;
export const IMG_LOVE_STORY = `https://user-images.githubusercontent.com/10141928/146289521-e97786dc-98a1-43d3-9b0f-e9353b168766.jpg`;

export const IMG_PHOTO_1 = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_PHOTO_1.jpg?updatedAt=1728368092310`;
export const IMG_PHOTO_2 = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_PHOTO_2.jpg?updatedAt=1728368091984`;
export const IMG_PHOTO_CONTENT = `https://ik.imagekit.io/7spuwnvx8a/alesnathasya/IMG_PHOTO_CONTENT.jpg?updatedAt=1728368091779`;

export const IMG_COVID = {
  id: `https://user-images.githubusercontent.com/103095433/241068547-20f04f29-1531-4bc2-a5e5-c7e3ce1c2805.png`,
  en: `https://user-images.githubusercontent.com/103095433/241068561-c7d17d12-c32f-44a1-834a-af73e655b0b6.jpg`,
};

export const LOGO_INVITATO = `https://ik.imagekit.io/invitatoid/global-assets/invitato_hs3nyqsuwy_.png?updatedAt=1638541184695`;
